import { createSelector } from '@reduxjs/toolkit';
import { selectOrder } from '../orderSelectors.ts';
import { selectCommentaryV2 } from './selectCommentary.ts';
import { parseMarketConditionsGeoType } from '../../../../modules/appraisifyCommentary/utils/parseMarketConditionsGeoType.ts';

export const selectCurrentMarketAggregateData = createSelector(
  [selectOrder, selectCommentaryV2],
  (order, commentary) => {
    const {marketAggregateData} = order;
    if (!marketAggregateData) {
      return undefined;
    }
    if (!commentary?.marketConditionsV2?.filter.type) {
      return undefined;
    }
    const filterType = parseMarketConditionsGeoType(commentary.marketConditionsV2?.filter.type);
    const filterValue = commentary.marketConditionsV2?.filter.value;

    const aggregateDataForGeo = marketAggregateData.find((data) => data.geoType === filterType && (data.geoId === filterValue || data.geoType !== 'zip'));
    if (!aggregateDataForGeo) {
      if (marketAggregateData.length > 0) {
        return marketAggregateData[0];
      }
      return undefined;
    }
    return aggregateDataForGeo;
  }
);

export const selectMarketAggregateData = createSelector(
  [selectOrder],
  (order) => order.marketAggregateData
);
